import ButtonGroup from '@mui/material/ButtonGroup';
import { ExpandableButtons } from './ExpandableButtons';
import { PriceCrypto, useCurrency } from 'src/contexts/CurrencyContext';
import { CryptoChain } from 'src/util/CryptoChain';

export type ItemCardButtonsProps = {
  lowestAsk?: number;
  priceHourly?: string;
  chainId: number;
  itemId: string;
  contractAddress: string;
  rentable?: boolean;
  rentedUntil?: Date;
  isOwner?: boolean;
  showAsWhitelisted: boolean;
  isWhitelisted?: boolean;
  hasRentOffer: boolean;
  contractType: string | null;
  isItemRented?: boolean;
};

export const ItemCardButtons = ({
  lowestAsk,
  priceHourly,
  chainId,
  itemId,
  contractAddress,
  rentable = false,
  rentedUntil,
  isOwner = false,
  showAsWhitelisted,
  isWhitelisted = false,
  hasRentOffer,
  contractType,
  isItemRented = false,
}: ItemCardButtonsProps) => {
  const { formatFiat, formatCrypto } = useCurrency();
  const { coin } = CryptoChain.from(chainId);
  const priceBuyNow: PriceCrypto | undefined = lowestAsk
    ? {
        wei: lowestAsk,
        cryptocurrency: coin,
      }
    : undefined;
  const lowestAskFormatted = priceBuyNow
    ? `${formatCrypto(priceBuyNow)} (${formatFiat(priceBuyNow)})`
    : undefined;
  const priceHourlyFormatted = priceHourly
    ? `${formatCrypto({
        wei: priceHourly,
        cryptocurrency: CryptoChain.MATIC.coin, // TODO: multiple options
      })} / Hour`
    : undefined;
  return (
    <ButtonGroup
      fullWidth
      sx={{
        gap: 1,
        '& .MuiButtonGroup-grouped': {
          minWidth: '25px',
        },
      }}
    >
      <ExpandableButtons
        isOwner={isOwner}
        rentable={rentable}
        rentedUntil={rentedUntil}
        lowestAskFormatted={lowestAskFormatted}
        priceHourlyFormatted={priceHourlyFormatted}
        itemId={itemId}
        chainId={chainId}
        contractAddress={contractAddress}
        showAsWhitelisted={showAsWhitelisted}
        isWhitelisted={isWhitelisted}
        hasRentOffer={hasRentOffer}
        contractType={contractType}
        isItemRented={isItemRented}
      />
    </ButtonGroup>
  );
};
